"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDate = isDate;

function isDate(value) {
  return value instanceof Date && !isNaN(+value);
}